import * as React from 'react';
import * as crew from "./style.module.scss";
export const Crew = () => {
  return (
    <section className={crew.crew}>
      <div className="container">
        <div className={crew.wrap}>
          <h2>Наша команда</h2>
          <div className={crew.inner}>
            <img src="https://fs.advance.ru/landing-pages/about/comand-320.png" alt="" className={crew.img}/>
            <img src="https://fs.advance.ru/landing-pages/about/crew-bg-lp.png" alt="" className={crew.imgLp}/>
            <ul>
              <li>
                <img src="https://fs.advance.ru/landing-pages/about/ag-small.png" alt=""/>
                <h3>Генеральный директор —<br/>Александр Згода</h3>
              </li>
            </ul>
            <p>Более 200 профессионалов, которые любят свою работу: создатели курсов, разработчики, методисты, педагоги, менеджеры по работе с клиентами, дизайнеры и многие другие.</p>
            <p><strong>Нас объединяет цель — делать качественные образовательные продукты, которые помогают взрослым и детям любить учиться и достигать новых высот в школе, работе и других сферах жизни.</strong></p>
          </div>
        </div>
      </div>
    </section>
  );
};
